import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dashboard-shell" }
const _hoisted_2 = { class: "dashboard-panel table-panel" }
const _hoisted_3 = { class: "panel-head" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "section-eyebrow" }, "Realtime"),
  /*#__PURE__*/_createElementVNode("h2", null, "节点监控")
], -1)
const _hoisted_5 = { class: "details-section" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "panel-head details-head" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "section-eyebrow" }, "Details"),
    /*#__PURE__*/_createElementVNode("h2", null, "节点详情")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sakura_fall = _resolveComponent("sakura-fall")!
  const _component_the_header = _resolveComponent("the-header")!
  const _component_the_error = _resolveComponent("the-error")!
  const _component_dashboard_overview = _resolveComponent("dashboard-overview")!
  const _component_update_time = _resolveComponent("update-time")!
  const _component_servers_table = _resolveComponent("servers-table")!
  const _component_servers_card = _resolveComponent("servers-card")!
  const _component_the_footer = _resolveComponent("the-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_sakura_fall),
    _createVNode(_component_the_header),
    _withDirectives(_createVNode(_component_the_error, null, null, 512), [
      [_vShow, !_ctx.servers]
    ]),
    _createElementVNode("main", _hoisted_1, [
      _createVNode(_component_dashboard_overview, { servers: _ctx.servers }, null, 8, ["servers"]),
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_update_time, { updated: _ctx.updated }, null, 8, ["updated"])
        ]),
        _createVNode(_component_servers_table, { servers: _ctx.servers }, null, 8, ["servers"])
      ]),
      _createElementVNode("section", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_servers_card, { servers: _ctx.servers }, null, 8, ["servers"])
      ])
    ]),
    _createVNode(_component_the_footer)
  ], 64))
}